import './form-reward-type.scss';
import { useFormContext } from "react-hook-form";
import { RewardTypeFormSchema } from "@factory/form/form.rule";
import InputDigitControl from "@shared/ui/hook-form/input-digit-control/input-digit-control";
import InputControl from "@shared/ui/hook-form/input-control/input-control";
import InputDateControl from "@shared/ui/hook-form/input-date-control/input-date-control";
import CheckboxControl from "@shared/ui/hook-form/checkbox-control/checkbox-control";

type InputFormSchema = RewardTypeFormSchema;
export function FormRewardType() {
  const { control } = useFormContext<RewardTypeFormSchema>();
  return (
    <div id="FormRewardType" className="reward-type">
      <InputControl<InputFormSchema>
        control={control}
        name="name"
        label="Name"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter name"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="description"
        label="Description"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter description"
      />
      <InputControl<InputFormSchema>
        control={control}
        name="tenant"
        label="Tenant"
        className="w-full md:w-3/4"
        containerClassName="pb-2"
        placeholder="Enter tenant"
      />
    </div>
  );
}

export default FormRewardType;